import { forwardRef } from 'react'

import { WithClassName } from 'shared/types/general.types'
import { cn } from 'utils/style'

import type { Ref } from 'react'

type SwitchProps = WithClassName<{
	name: string
	label: string
	description?: string
	checked?: boolean
	disabled?: boolean
	onChange?: (e: any) => void
}>

export const Switch = forwardRef(
	(
		{ name, label, description, className, disabled = false, onChange, ...rest }: SwitchProps,
		ref: Ref<HTMLInputElement>
	) => {
		return (
			<label className={cn('flex w-full items-start justify-between gap-6', className)}>
				<span className="min-w-0">
					<span className="block text-[13px] font-semibold text-foreground">{label}</span>
					{description && (
						<span className="mt-0.5 block max-w-lg text-[12px] leading-relaxed text-muted-foreground">
							{description}
						</span>
					)}
				</span>
				<span className="relative mt-0.5 inline-flex h-6 w-11 shrink-0">
					<input
						type="checkbox"
						role="switch"
						name={name}
						disabled={disabled}
						onChange={onChange}
						className="peer absolute inset-0 z-10 m-0 cursor-pointer opacity-0 disabled:cursor-not-allowed"
						{...rest}
						ref={ref}
					/>
					<span className="absolute inset-0 rounded-full bg-muted-foreground/25 transition-colors peer-checked:bg-success peer-focus-visible:ring-2 peer-focus-visible:ring-success/30 peer-disabled:opacity-50" />
					<span className="pointer-events-none absolute left-0.5 top-0.5 h-5 w-5 rounded-full bg-card shadow-sm transition-transform peer-checked:translate-x-5" />
				</span>
			</label>
		)
	}
)
